import React, { useState } from 'react';
import { voteValues } from '../../../../constants/chatbot';
import {
    Action,
    IChatData,
    IChatState,
} from '../../../../interfaces/chat.interface';
import { voteMessage } from '../../../../services/chatbot.services';
import { LikeIcon } from '../../like-icon/LikeIcon';
import './ChatText.scss';

// @ts-ignore
import chatIcon from '../../../../assets/icons/CDA/chat.svg';

interface IProps {
    messageData: IChatData;
    chatState: IChatState;
    setChatState: React.Dispatch<Action>;
}

const ChatText = ({ messageData, chatState, setChatState }: IProps) => {
    const [clicked, setClicked] = useState(false);

    const handleRating = async (rate: number) => {
        setClicked(true);
        if (!clicked && chatState.sessionId && !messageData.vote) {
            const res = await voteMessage(
                chatState.sessionId,
                String(messageData.id),
                rate
            );
            if (res?.text === 'OK') {
                setChatState({
                    type: 'VOTE_MESSAGE',
                    messageId: messageData.id,
                    vote: rate,
                });
            } else {
                setClicked(false);
            }
        }
    };

    return (
        <div className={`a-chatText ${messageData.from}`} key={messageData.id}>
            <img className="a-chatText__logo" src={chatIcon} alt="chat icon" />
            <span
                className="a-chatText__text"
                dangerouslySetInnerHTML={{ __html: messageData.message }}
            />
            {messageData.from === 'Comfama' && messageData.id !== '1' && (
                <div className="a-chatText__rating">
                    <button
                        className={`a-chatText__rating__vote ${
                            messageData.vote && 'voted'
                        }`}
                        onClick={() => handleRating(voteValues.positive)}
                        aria-label="Votar"
                    >
                        <LikeIcon
                            isActive={messageData.vote === voteValues.positive}
                        />
                    </button>
                    <button
                        className={`a-chatText__rating__vote unlike ${
                            messageData.vote && 'voted'
                        }`}
                        onClick={() => handleRating(voteValues.negative)}
                        aria-label="Votar"
                    >
                        <LikeIcon
                            isActive={messageData.vote === voteValues.negative}
                        />
                    </button>
                </div>
            )}
        </div>
    );
};

export default ChatText;
